import React from 'react';
import { useTranslation } from 'react-i18next';

import { useNonce } from '../../../../hooks/use-nonce';
import { SkyviewContext } from '../../../skyview/skyview-state';
import { ToolIcon } from '../tool-icon';

const OcclusionCullingToolIcon = () => {
  const { t } = useTranslation();
  const [_, refresh] = useNonce();

  const { skyview } = React.useContext(SkyviewContext);

  return (
    <ToolIcon
      active={!skyview.getOcclusionCulling()}
      callback={() => {
        skyview.setOcclusionCulling(!skyview.getOcclusionCulling());
        refresh();
      }}
      icon={['fal', 'dice-d8']}
      tooltip={{
        title: t('occlusionCulling.tooltip.title', { ns: 'skyviewToolbar' }),
        text: t('occlusionCulling.tooltip.text', { ns: 'skyviewToolbar' }),
      }}
    />
  );
};

export { OcclusionCullingToolIcon };
